import LeagueInvitesView from '../Invites';
import Preloader from '../../../utils/Preloader';
import { redirectTo } from '../../../utils';

/**
 * @desc Core Regeneration Invite View Class
 */
export default class CoreRegenerationInviteView extends LeagueInvitesView {
	get template() {
		throw new Error("Need set template for child CoreRegenerationInviteView class");
	}

	get className() {
		return super.className + " league-regeneration-invites-page";
	}

	/**
	 * Set all UI for this view
	 * @returns object
	 */
	ui() {
		return {
			...super.ui(),
			load_more:  '.js-load-more',
			email_item: '.js-email-item',
			first_name: '.js-invite-first-name',
			invite_all: '.js-invite-all'
		};
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	events() {
		return {
			...super.events(),
			'click @ui.load_more':    'loadMore',
			'click @ui.send_invites': 'sendInvites',
			'click @ui.invite_all':   'inviteAll'
		};
	}

	/**
	 *    Initialize view data
	 */
	async initialize() {
		this.league_id     = this.getOption( 'league_id' );
		this.old_league_id = this.getOption( 'old_league_id' );

		Preloader.show();
		await this.fetchData();
		this.updateModel()
			.updateView();
		Preloader.hide();
	}

	/**
	 * Get all base data for this class
	 * @returns {*|Promise.<Object>}
	 */
	fetchData() {
		return this.model.setShowUrl().fetch(
			{
				data: {
					'id': this.league_id
				}
			}
		);
	}

	updateModel() {
		this.model.set( 'id', this.league_id );
		this.updateView();
		return this;
	}

	loadMore() {
		this.getUI( 'email_item' ).removeClass( 'hidden' );
		this.getUI( 'load_more' ).hide();
	}

	/**
	 *
	 * @returns {Array}
	 */
	get emailLists() {
		let regenerate_emails = [];

		this.getUI( 'invite_email' ).each( ( key, element ) => {

			let $element   = $( element ),
				is_checked = $element.next().find( 'input' ).is( ':checked' );

			if (
				$( element ).val() !== '' &&
				is_checked
			) {
				let item = {
					'firstname': $element.prev().val(),
					'email':     $element.val()
				};
				regenerate_emails.push( item );
			}
		} );

		return regenerate_emails;
	}

	sendInvitesSuccess() {
		let url = `fantasy/league/${this.league_id}/regenerate/congratulation`;
		redirectTo( url );
	}

	inviteAll() {
		const data = {
			new_id: this.league_id,
			old_id: this.old_league_id
		};
		this.model.inviteAll( data );
	}
}